<div class="rs-flex rs-flex-dir-col rs-maxh">
  <h3 class="rs-tit6">{{ 'cloud.download.title' | translate }}</h3>
  <div class="rs-flex-row">
    <div class="rs-flex-column">
      <a
        href="{{ 'cloud.download.mac.link' | translate }}"
        target="_blank"
        data-tms-event="link-click"
        attr.data-tms-link-zone="{{ 'cloud.download.title' | translate }}"
        data-tms-link-name="download mac"
        attr.data-tms-link-url="{{ 'cloud.download.mac.link' | translate }}"
      >
        <img alt="Download for Mac" src="{{ 'cloud.download.mac.image.path' | translate }}" />
      </a>
    </div>
    <div class="rs-flex-column">
      <a
        href="{{ 'cloud.download.windows.link' | translate }}"
        target="_blank"
        data-tms-event="link-click"
        attr.data-tms-link-zone="{{ 'cloud.download.title' | translate }}"
        data-tms-link-name="download windows"
        attr.data-tms-link-url="{{ 'cloud.download.windows.link' | translate }}"
      >
        <img
          alt="Download for Windows"
          src="{{ 'cloud.download.windows.image.path' | translate }}"
        />
      </a>
    </div>
  </div>
  <div class="rs-me"></div>
  <div class="rs-flex-grow rs-flex rs-flex-bottom">
    <p>
      <button
        class="rs-btn-no-style rs-link rs-txt-hover"
        (click)="click()"
        aria-controls="ac-downloadPanel"
      >
        {{ 'cloud.download.alsoForMobile' | translate }}
      </button>
    </p>
  </div>
</div>
